"use client"
import React, { useState, useEffect, useCallback } from "react"
import * as classes from "./team.module.scss"
// import { useBreakpoint } from "../../../hooks/breakpoints"
import SlideWrapper from "@/components/Shared/SlideWrapper/slideWrapper"
// import Carousel from "nuka-carousel"
// import { Carousel } from "nuka-carousel"
import { cn } from "@/utils/cn"
import useEmblaCarousel from 'embla-carousel-react';
const Team = ({ teamProfilesData, theme }) => {


	const [emblaRef, emblaApi] = useEmblaCarousel({
		axis: 'x',
		dragFree: true,
		slidesToScroll: 1,
		skipSnaps: true,
		containScroll: 'trimSnaps',
	});

	const [canPrev, setCanPrev] = useState(false);
	const [canNext, setCanNext] = useState(false);

	/* обновляем состояние стрелок при каждом выборе */
	const onSelect = useCallback(() => {
		if (!emblaApi) return;
		setCanPrev(emblaApi.canScrollPrev());
		setCanNext(emblaApi.canScrollNext());
	}, [emblaApi]);

	useEffect(() => {
		if (!emblaApi) return;
		onSelect();                     // инициализация
		emblaApi.on('select', onSelect);
		emblaApi.on('reInit', onSelect);
	}, [emblaApi, onSelect]);
	const showArrows = canPrev || canNext

	const leftButton = () => {
		return (
			<button
				onClick={() => emblaApi?.scrollPrev()}
				disabled={!canPrev}
				className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="arrow"
					className="object-cover"
					style={{
						transform: "rotate(90deg)",
					}}
				/>
			</button>
		)
	}
	const rightButton = () => {
		return (
			<button
				onClick={() => emblaApi?.scrollNext()}
				disabled={!canNext}
				className=" disabled:opacity-40 cursor-pointer disabled:cursor-default"
			>
				<img
					src="/icons/arrow_down_icon.svg"
					alt="arrow"
					className="object-cover"
					style={{
						transform: "rotate(-90deg)",
					}}
				/>
			</button>
		)
	}
	return (
		<>
			<div className={classes["teamWrapper"]}>
				<div
					className={classes["title"]}
					style={{
						borderBottomColor: theme.lineColor,
						color: theme.primaryTextColor,
						fontFamily: theme?.fontFamilyPrimary,
						marginBottom: '20px'
					}}
				>
					TEAM
				</div>
				<div className="flex items-center  max-w-full mx-auto w-full mb-10 md:mb-0">
					<div className="size-[30px] flex justify-start items-center">{showArrows && leftButton()}</div>

					<div
						className="max-w-[calc(100%_-_60px)]  overflow-hidden cursor-grab  mx-auto "
						// className="max-w-[calc(100%_-_60px)] overflow-hidden cursor-grab  mx-auto border border-red-500"
						ref={emblaRef}
					>
						{/* <div className="max-w-[90%] overflow-hidden cursor-grab xl:max-w-fit mx-auto" ref={emblaRef}> */}
						<div className="flex gap-10 ">
							{teamProfilesData.map((item, index) => (
								// {teamProfilesData.slice(0, 3).map((item, index) => (
								<SlideWrapper triggerOnce direction={"up"} key={index} style={{ flex: '0 0 auto' }}>
									<div className={classes["profileTab"]}>
										{item.dpSrc && (
											<div className="w-[130px] h-[130px] flex justify-center items-center" style={{ flex: '0 0 auto' }}>
												<img
													src={item.dpSrc}
													alt="profile pic"
													className="block mx-auto object-contain h-full "
												/>
											</div>
											// <div className={classes["profilePic"]}>
											// 	<img src={item.dpSrc} alt="profile pic" />
											// </div>
										)}
										<div className={classes["profileDetail"]}>
											<div
												style={{
													color: theme.primaryTextColor,
													fontFamily: theme.fontFamilyPrimary,
												}}
											>
												{item.name}
											</div>
											<div
												style={{
													color: theme.secondaryTextColor,
													fontFamily: theme.fontFamilySecondary,
												}}
											>
												{item.role}
											</div>
											{item.serviceLink && (
												<div>
													<a
														href={item.serviceLink}
														target="_blank"
														rel="noreferrer"
													>
														{" "}
														<img
															src={item.serviceIcon}
															alt="icon pic"
															width="25px"
														/>
													</a>
												</div>
											)}
										</div>
									</div>
								</SlideWrapper>
							))}
						</div>
					</div>
					<div className="size-[30px] flex justify-end items-center">{showArrows && rightButton()}</div>

				</div>
			</div>
		</>
	)
}

// {
// 	teamProfilesData.map((item, index) => (
// 		<SlideWrapper triggerOnce direction={"up"} key={index}>
// 			<div className={classes["profileTab"]}>
// 				{item.dpSrc && (
// 					<div className={classes["profilePic"]}>
// 						<img src={item.dpSrc} alt="profile pic" />
// 					</div>
// 				)}
// 				<div className={classes["profileDetail"]}>
// 					<div
// 						style={{
// 							color: theme.primaryTextColor,
// 							fontFamily: theme.fontFamilyPrimary,
// 						}}
// 					>
// 						{item.name}
// 					</div>
// 					<div
// 						style={{
// 							color: theme.secondaryTextColor,
// 							fontFamily: theme.fontFamilySecondary,
// 						}}
// 					>
// 						{item.role}
// 					</div>
// 					{item.serviceLink && (
// 						<div>
// 							<a
// 								href={item.serviceLink}
// 								target="_blank"
// 								rel="noreferrer"
// 							>
// 								{" "}
// 								<img
// 									src={item.serviceIcon}
// 									alt="icon pic"
// 									width="25px"
// 								/>
// 							</a>
// 						</div>
// 					)}
// 				</div>
// 			</div>
// 		</SlideWrapper>
// 	))
// }
// const Team = ({ teamProfilesData, theme }) => {
//   const breakpoint = useBreakpoint()
//   const [slideToShow, setSlideToShow] = useState(6)
//   useEffect(() => {
//     breakpoint.sm || breakpoint.xs
//       ? setSlideToShow(1)
//       : breakpoint.md
//       ? setSlideToShow(2)
//       : breakpoint.l
//       ? setSlideToShow(3)
//       : setSlideToShow(3)
//   }, [breakpoint, slideToShow])
//   return (
//     <>
//       <div className={classes["teamWrapper"]}>
//         <div
//           className={classes["title"]}
//           style={{
//             borderBottomColor: theme.lineColor,
//             color: theme.primaryTextColor,
//             fontFamily: theme?.fontFamilyPrimary,
//           }}
//         >
//           TEAM
//         </div>

//         <div>
//           <Carousel
//             slidesToShow={slideToShow}
//             framePadding="0px 10px "
//             renderBottomCenterControls={false}
//             renderCenterLeftControls={({ previousSlide }) =>
//               slideToShow < teamProfilesData.length && (
//                 <button
//                   onClick={previousSlide}
//                   style={{
//                     border: "none",
//                     background: "transparent",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <img
//                     src="/icons/arrow_down_icon.svg"
//                     alt="arrow"
//                     style={{
//                       transform: "rotate(90deg) translateY(50px)",
//                     }}
//                   />
//                 </button>
//               )
//             }
//             renderCenterRightControls={({ nextSlide }) =>
//               slideToShow < teamProfilesData.length && (
//                 <button
//                   onClick={nextSlide}
//                   style={{
//                     border: "none",
//                     background: "transparent",
//                     cursor: "pointer",
//                   }}
//                 >
//                   <img
//                     src="/icons/arrow_down_icon.svg"
//                     alt="arrow"
//                     style={{
//                       transform: "rotate(-90deg) translateY(50px)",
//                     }}
//                   />
//                 </button>
//               )
//             }
//           >
//             {teamProfilesData.map((item, index) => (
//               <SlideWrapper triggerOnce direction={"up"} key={index}>
//                 <div className={classes["profileTab"]}>
//                   {item.dpSrc && (
//                     <div className={classes["profilePic"]}>
//                       <img src={item.dpSrc} alt="profile pic" />
//                     </div>
//                   )}
//                   <div className={classes["profileDetail"]}>
//                     <div
//                       style={{
//                         color: theme.primaryTextColor,
//                         fontFamily: theme.fontFamilyPrimary,
//                       }}
//                     >
//                       {item.name}
//                     </div>
//                     <div
//                       style={{
//                         color: theme.secondaryTextColor,
//                         fontFamily: theme.fontFamilySecondary,
//                       }}
//                     >
//                       {item.role}
//                     </div>
//                     {item.serviceLink && (
//                       <div>
//                         <a
//                           href={item.serviceLink}
//                           target="_blank"
//                           rel="noreferrer"
//                         >
//                           {" "}
//                           <img
//                             src={item.serviceIcon}
//                             alt="icon pic"
//                             width="25px"
//                           />
//                         </a>
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               </SlideWrapper>
//             ))}
//           </Carousel>
//         </div>
//       </div>
//     </>
//   )
// }

export default Team
